export interface UpdaterObject {
	firstname: string;
	lastname: string;
	alternateMail: string;
	job: string;
	title: string;
	phone: string;
	gsm: string;
	companyType: string;
	companyName: string;
	province: string;
	district: string;
	address: string;
	mailApprove: boolean;
}

export const UpdaterObjectInitialValue: UpdaterObject = {
	firstname: "",
	lastname: "",
	alternateMail: "",
	job: "",
	title: "",
	phone: "",
	gsm: "",
	companyType: "",
	companyName: "",
	province: "",
	district: "",
	address: "",
	mailApprove: false,
};
